import React from 'react';

const REGION_LABELS = {
  NZ: 'New Zealand',
  AU: 'Australia',
  US: 'the United States',
  UK: 'the United Kingdom',
  CA: 'Canada',
  global: 'the world',
};

const TrendingHero = ({ region, isLoggedIn, onSignIn }) => {
  const label = REGION_LABELS[region] || 'the world';
  return (
    <header className="trending-hero" data-testid="trending-hero">
      <div className="hero-inner">
        <div className="hero-top">
          <span className="eyebrow">Trending this week</span>
        </div>
        <h1 data-testid="trending-h1">
          What the flock is grazing on in{' '}
          <span className="hero-region">{label}</span>
        </h1>
        <p className="hero-sub">
          A live, region-aware leaderboard of the most-watched TV right now,
          powered by TMDB. Tap a show to track it; switch regions to peek at
          what other flocks are bingeing.
        </p>
        {!isLoggedIn && (
          <button
            type="button"
            data-testid="hero-signin-btn"
            className="hero-cta"
            onClick={onSignIn}
          >
            Join the flock
          </button>
        )}
      </div>

      <style jsx>{`
        .trending-hero {
          position: relative;
          padding: 5rem 1.5rem 3rem;
          overflow: hidden;
          background:
            radial-gradient(
              1100px 480px at 50% -200px,
              rgba(230, 47, 136, 0.18) 0%,
              rgba(230, 47, 136, 0) 60%
            ),
            #0a0a0a;
          border-bottom: 1px solid #161616;
        }
        .trending-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image: url('https://static.prod-images.emergentagent.com/jobs/46525505-572e-4851-9caa-d905875d9c8d/images/6cc432485312fc002b1c732cbc6e05b551478faaaeaf3b0647e690ebb54b9d3d.png');
          background-size: cover;
          background-position: center;
          opacity: 0.08;
          pointer-events: none;
        }
        .hero-inner {
          position: relative;
          max-width: 1280px;
          margin: 0 auto;
          z-index: 1;
        }
        .hero-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          flex-wrap: wrap;
          margin-bottom: 1.25rem;
        }
        .eyebrow {
          color: #E62F88;
          font-size: 0.72rem;
          font-weight: 800;
          letter-spacing: 0.22em;
          text-transform: uppercase;
        }
        h1 {
          font-size: clamp(2.25rem, 5vw, 3.75rem);
          font-weight: 900;
          color: #fff;
          letter-spacing: -0.02em;
          margin: 0 0 1rem;
          line-height: 1.05;
          max-width: 920px;
        }
        .hero-region {
          color: #E62F88;
          background: linear-gradient(120deg, #E62F88 0%, #ff7eb6 100%);
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .hero-sub {
          font-size: 1.05rem;
          line-height: 1.6;
          color: #a1a1aa;
          max-width: 640px;
          margin: 0 0 2rem;
        }
        .hero-cta {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: #E62F88;
          color: #000;
          padding: 0.85rem 1.6rem;
          border-radius: 8px;
          border: none;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          transition: background 0.18s, transform 0.18s;
        }
        .hero-cta:hover {
          background: #ff4f9e;
          transform: translateY(-1px);
        }
      `}</style>
    </header>
  );
};

export default TrendingHero;
